export const ROLE_ADMIN = 'Administrator';
export const MAX_ADMIN_COUNT = 4;
